import type { TextProps } from '@frontend/web-react';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';

type CardHeaderProps = {
  leftIconName?: IconName;
  onClickRightIcon?: () => void;
  rightIconName?: IconName;
  subtitle?: string;
  title?: string;
  titleTextProps?: TextProps;
};

export const CardHeader = ({
  leftIconName,
  onClickRightIcon,
  rightIconName,
  subtitle,
  title,
  titleTextProps,
}: CardHeaderProps) => (
  <XStack className="gap-sm items-center">
    <XStack className="grow-1 gap-md items-center">
      {leftIconName ? (
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        <YStack className="bg-surfaceSecondary size-[40px] items-center justify-center rounded-[20px]">
          <Icon name={leftIconName} size={24} />
        </YStack>
      ) : null}
      <YStack className="gap-xs">
        {title ? (
          <Text type="h5" {...titleTextProps}>
            {title}
          </Text>
        ) : null}
        {subtitle ? (
          <Text color="secondary" type="p-sm">
            {subtitle}
          </Text>
        ) : null}
      </YStack>
    </XStack>
    {rightIconName ? <Icon name={rightIconName} onClick={onClickRightIcon} size={24} /> : null}
  </XStack>
);
